<ul>
  <li><a href="/" >VoxPop Home</a></li>
  @if (CanReview()) {
    <div class="wrap">
      <li><a routerLink="/review/dashboard" routerLinkActive="active">Dashboard</a></li>
      <li><a routerLink="/review/topics" routerLinkActive="active">Topics</a></li>
      <li><a routerLink="/review/wires" routerLinkActive="active">Wires</a></li>
      <li><a routerLink="/review/programmes" routerLinkActive="active">Programmes</a></li>
    </div>
  }
  @if (CanAdminister()) {
    <div class="wrap">
      <li><a routerLink="/review/profiles" routerLinkActive="active">Reviewers</a></li>
    </div>
  }
  @if (IsLoggedIn()) {
    <div>
      <li><a href="/auth/logout" id="logout">Logout</a></li>
    </div>
  }
</ul>
